import { setSelectedItemDescriptionId } from '../../../State/selectedItemDescriptionId';
import { setShowItemDescriptionModal } from '../../../State/showItemDescriptionModal';

export default (props) => async (dispatch) => {

  dispatch(setSelectedItemDescriptionId(props.id))
  dispatch(setShowItemDescriptionModal(true));
  
}